import * as React from "react";
import { Route, RouteProps, RouteComponentProps, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { IApplicationState } from "../../redux/reducers";
import { routes } from "../../routes/routes";
import Subscribe from "../../routes/subscribe";
import userService from "../../services/userService";
import { useEffect, useState } from "react";
import { user } from "../../redux/actions/actionContants";
import { IUserState } from "../../redux/reducers/userReducer";
import Loader from "../loader";
import RequestAdmin from "../../routes/account/company/components/requestAdmin";

export interface IDynamicRouteSegments {
	subLocationId: string;
}

interface PrivateRoutePropType extends RouteProps {
	isLoggedIn: boolean;
	user: IUserState | undefined;
	getUserProfile: () => Promise<any>;
	component: React.ComponentType<RouteComponentProps<IDynamicRouteSegments>>;
	logout: () => void;
}

const PrivateRoute: React.FC<PrivateRoutePropType> = ({
	component: Component,
	isLoggedIn,
	user,
	getUserProfile,
	logout,
	...rest
}) => {
	const [loading, setLoading] = useState<boolean>(true);
	const [modal, setModal] = useState<boolean>();

	useEffect(() => {
		setLoading(true);
		getUserProfile().finally(() => {
			setLoading(false);
		});
	}, []);

	const isSubscribed = () => {
		return user?.profile?.company?.subscription_type != "" || user?.profile?.role === "JF_ADMIN";
	};

	const hasAccess = () => {
		return (
			user?.profile?.role === "COMPANY_ADMIN" ||
			user?.profile?.role === "JF_ADMIN" ||
			user?.profile?.has_access
		);
	};

	const isPublicUnderApp = (path: string) => {
		const normalizedPath = path.replace(/\/$/, "");
		const publicRoutes = [
			routes.DASHBOARD,
			routes.AICHATDASHBOARD,
			"/app" // allow base path to be handled by App
		].map(r => r.replace(/\/$/, ""));
		
		return publicRoutes.includes(normalizedPath);
	};

	return (
		<Route
			{...rest}
			render={(props: RouteComponentProps<IDynamicRouteSegments>) => {
				const isPublic = isPublicUnderApp(props.location.pathname);

				if (isLoggedIn || isPublic) {
					// Only show loader for private routes when logged in
					if (loading && isLoggedIn && !isPublic) {
						return <Loader isLoading={loading} type={"spin"} fullScreen={true} />;
					}
					
					// If logged in and loading is done, or if it's a public route
					if (isLoggedIn) {
						if (isSubscribed()) {
							if (hasAccess()) {
								return <Component {...props} />;
							} else {
								return <RequestAdmin isOpen={true} toggle={() => setModal(!modal)} logout={logout} />;
							}
						} else {
							return <Subscribe />;
						}
					} else {
						// Guest access to allowed sub-routes or base /app
						return <Component {...props} />;
					}
				} else {
					// Not logged in and not a public route
					return <Redirect to={routes.LOGIN} />;
				}
			}}
		/>
	);
};

const mapStateToProps = (state: IApplicationState) => ({
	isLoggedIn: state.user.isLoggedIn,
	user: state.user
});

const mapDispatchToProps = {
	getUserProfile: () => userService.getUserProfile(),
	logout: () => userService.logout()
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);

// export default PrivateRoute;
